module.exports = {
	extends: [
		'/',
		'base',
		'trees',
		'tree'
	],

	config: {
		treeConfig: {
			plugins: [
				'types',
				'search',
				'checkbox'
			],
			core: {
				data:       undefined,
				multiple:   true
			},
			checkbox: {
				three_state: false,
				cascade: 'down+undetermined'
			}
			// plugins: [
			// 'contextmenu', 'dnd', 'search',
			// 'state', 'types', 'wholerow'
			// 'state',
			// 'types',
			// 'checkbox'
			// 'contextmenu',
			// 'dnd'
			// ]
		}
	}
};
